import { logger } from '@/ui/utilities/instrumentation'
import { useCandidateCardViewStore } from '@jobilla/nexus-sdk'
import { useEffect } from 'react'

export function useReportCardView(candidateId: string): void {
	const { mutate } = useCandidateCardViewStore({
		onError: (error, variables) => {
			logger.error(error, {
				category: 'analytics',
				data: { candidateId: variables.candidate },
				tags: { feature: 'candidate-card-view' },
			})
		},
	})

	useEffect(() => {
		mutate({ candidate: candidateId })
	}, [candidateId, mutate])
}
